import { Glue42 } from "../../glue";
import { HotkeysImpl } from "./hotkeys";

export function factory(agm: Glue42.AGM.API): Glue42.Hotkeys.API & { ready: () => Promise<void>; } {
    const hotkeys = new HotkeysImpl(agm);

    return {
        register: hotkeys.register.bind(hotkeys),
        unregister: hotkeys.unregister.bind(hotkeys),
        unregisterAll: hotkeys.unregisterAll.bind(hotkeys),
        isRegistered: hotkeys.isRegistered.bind(hotkeys),

        ready: () => Promise.resolve()
    };
}
